import { requests } from 'api';
import { AgeGroup } from './types';

const apiBaseUrl = '/api/agegroups';

export const AgeGroupsApi = {
  getAll: (): Promise<AgeGroup[]> => requests.get(apiBaseUrl),
};
